export default {
  setCouponGames(state, value) {
    state.couponGames = value
  },
  setCouponHistoryGames(state, value) {
    state.couponHistoryGames = value
  },
  setAllCouponList(state, value) {
    state.allCouponList = value
  },
  setHistoryCouponList(state, value) {
    state.historyCouponList = value
  },
}
